import { env, EnvType } from './env'


export const sanityCheck = () => {
    const DEV = ['https://wp--dev.gilddevel.com/backoffice/#/', '/']
    const PROD = ['https://blog.yourgild.com/backoffice/#/']

    const { basePath = '' }: EnvType = env

    if (PROD.includes(basePath)) {
        return (window.location.origin === 'https://blog.yourgild.com')
    }
    if (DEV.includes(basePath)) {
        // Any subdomain of gilddevel.com counts as a dev origin — covers the
        // legacy wp--dev.gilddevel.com WP host plus SST-deployed subdomains
        // like staging-bp-backoffice.gilddevel.com and dev-alice-backoffice.gilddevel.com.
        // backoffice.yourgild.com is the SST prod hostname (the v2 distro
        // serves it as a CloudFront alias; basePath stays '/').
        return (
            window.location.origin === 'http://localhost:3000' ||
            window.location.origin === 'http://localhost:3001' ||
            window.location.origin === 'https://backoffice.yourgild.com' ||
            /^https?:\/\/[a-z0-9][a-z0-9-]*\.gilddevel\.com$/.test(window.location.origin)
        )
    }
    
    return false
}
